import { ONBOARDING_TRANSITION_DURATION_MS } from "@/features/user-profile/constants/onboarding-transition";
import { triggerHaptic } from "@/utils/haptics";
import { cn } from "@/utils/cn";

interface SelectablePillProps {
  label: string;
  onClick: () => void;
  variant?: "default" | "selected" | "danger" | "active";
  description?: string;
  disabled?: boolean;
}

export const SelectablePill = ({
  label,
  onClick,
  variant = "default",
  description,
  disabled = false,
}: SelectablePillProps) => {
  const handleClick = () => {
    triggerHaptic();
    onClick();
  };

  const pill = (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled}
      style={{ transitionDuration: `${ONBOARDING_TRANSITION_DURATION_MS}ms` }}
      className={cn(
        "relative flex h-[50px] w-full max-w-[321px] items-center justify-center rounded-[40px] border bg-white px-[39px] text-center text-base leading-tight font-medium transition-colors",
        "disabled:cursor-not-allowed",
        variant === "default" && [
          "border-purple-700 text-purple-700",
          "shadow-[inset_0_-12px_6px_0_rgba(98,10,213,0.06)]",
        ],
        variant === "selected" && [
          "border-[#ff008c] text-[#ff008c]",
          "shadow-[inset_0_-12px_6px_0_rgba(255,0,140,0.06)]",
        ],
        variant === "danger" && [
          "border-[#ff008c] text-[#ff008c]",
          "shadow-[inset_0_-12px_6px_0_rgba(255,0,140,0.06)]",
        ],
        variant === "active" && "border-purple-700 bg-purple-700 text-white",
      )}
    >
      {label}
      {variant === "selected" && (
        <svg
          aria-hidden
          viewBox="0 0 13 10"
          fill="none"
          className="absolute top-1/2 right-[14px] h-[10px] w-[13px] -translate-y-1/2"
        >
          <path
            d="M1 5l4 4L12 1"
            stroke="#ff008c"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </button>
  );

  if (!description) return pill;

  return (
    <div className="flex w-full max-w-[321px] flex-col items-center gap-3">
      {pill}
      <p className="text-center text-[13px] font-medium text-black opacity-70">{description}</p>
    </div>
  );
};
